<template>
  <section>
    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">
          株主・投資家の皆さまへ
        </h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          TOP MESSAGES
        </h3>

        <div class="l-service-content-inner">
          <p class="sentence sentence-mt sentence-ir-mb">
            株式会社旅工房は、1994年4月18日の設立以来、徹底してお客様の視点に立って、「お客様一人ひとりの自由な旅づくり」を行うことを目指して成長してまいりました。
            <br />設立より24年目を迎える2017年4月18日に、当社は東京証券取引所マザーズ市場に上場いたしました。これもひとえに、お客様、お取引先様など多くの関係者の皆様方のご支援の賜物と心より御礼申し上げます。
          </p>

          <p class="sentence sentence-mt sentence-ir-mb">
            当社は、旅行商品の販売チャネルをインターネットに限定する一方、旅行先の情報に精通した「トラベル・コンシェルジュ」が旅行のご相談やカスタマイズに応じることで、オンライン予約の利便性を確保しつつ、「人」による柔軟性や温かみを組み合わせた「ハイブリッド戦略」を特長としており、専門性が高く柔軟な商品企画やお客様対応を強みとしております。
          </p>

          <p class="sentence sentence-mt sentence-ir-mb">
            今後も、これらの特長や強みを活かして、お客様のニーズに即した付加価値の高い旅行商品を提供してまいります。
            <br />そして、更なる成長のために、システム投資やマーケティングの強化を継続するとともに、商品企画力及びトラベル・コンシェルジュの接客力・対応力の向上のための教育研修を積極的に推進してまいります。
          </p>

          <p class="sentence sentence-mt sentence-ir-mb">
            これからも常に初心と感謝の心を忘れず、多くのお客様に支持していただける企業を目指してまいります。皆さまにおかれましては、引き続き、変わらぬご支援を賜りますよう、心よりお願い申し上げます。
          </p>

          <p class="sentence sentence-mt sentence-ir-mb president_name">
            代表取締役社長
            <br />小林 祐樹
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "株主・投資家の皆さまへ",
      titleTemplate: "株主・投資家の皆さまへ | IR情報 | 株式会社 旅工房",
    };
  },
};
</script>
